import { trackEvent } from "@amplio-common/analytics";
import { currentUser } from "@app/routes/auth/selectors";
import { selectTreatment } from "@app/routes/treatmentV3/store/treatmentServerDataSlice";
import { ROLES } from "@app/constants";
import { wsSelectAllStudentsStatus, wsSelectStudentStatusById } from "@app/routes/treatmentV3/store/websocketSlice";
import { selectAllStudentsStatus as adminSelectAllStudentsStatus } from "@app/routes/treatmentV3/store/administrationSlice";
import { selectAllStudentsStatus as contentSelectAllStudentsStatus, selectPinnedBoardMode, selectStudentStatusById as contentSelectStudentStatusById, selectPinnedBoard } from "@app/routes/treatmentV3/store/contentSlice";
import { PREVIEW_BOARD_ID } from "@app/routes/treatmentV3/constants";
import { selectIsLocked, selectBoardMode } from "@app/routes/treatmentV3/store/studentSlice";
import { videoSelectAllStudentsStatus } from "@app/routes/treatmentV3/store/videoSlice";

const getTherapistWithStudentDefaultProperties = (state, studentId) => {
  const wsStudentStatus = (s => wsSelectStudentStatusById(s, studentId))(state);
  const contentStudentStatus = (s => contentSelectStudentStatusById(s, studentId))(state);

  return ({
    relevant_to_student: studentId,
    student_is_locked: contentStudentStatus.isLocked,
    student_is_ws_connected: wsStudentStatus.wsConnected,
  });
};

const getTherapistWithTreatmentDefaultProperties = (state, studentId) => {
  const wsAllStudentsStatus = wsSelectAllStudentsStatus(state);
  const adminAllStudentsStatus = adminSelectAllStudentsStatus(state);
  const contentAllStudentsStatus = contentSelectAllStudentsStatus(state);
  const videoAllStudentsStatus = videoSelectAllStudentsStatus(state);
  
  const relevantStudentProps = studentId ? getTherapistWithStudentDefaultProperties(state, studentId) : {};

  return ({
    num_students_connected: wsAllStudentsStatus.filter(stu => stu.wsConnected).length,
    num_students_arrived: adminAllStudentsStatus.filter(stu => stu.isArrived).length,
    num_students_locked: contentAllStudentsStatus.filter(stu => stu.isLocked).length,
    num_planned_students: adminAllStudentsStatus.length,
    num_of_students_connected_to_video: videoAllStudentsStatus.filter(stu => stu.isVideoApproved).length,
    students_grades: adminAllStudentsStatus.filter(stu => stu.studentGrade).map(stu => stu.studentGrade),
    ...relevantStudentProps,
  });
};

const getTherapistDefaultProperties = (state, studentId, currUser, treatment) => {
  const therapistTreatmentDefaultProperties = treatment ? getTherapistWithTreatmentDefaultProperties(state, studentId) : {};

  return ({
    service_model: currUser.is_amplio_employee || currUser.is_tipuli_employee ? "CaaS" : "SaaS",
    therapist_id: currUser.id,
    is_classroom: !treatment,
    board_mode_currently_displayed: selectPinnedBoardMode(state),
    pinned_board: selectPinnedBoard(state) === PREVIEW_BOARD_ID ? "preview" : "student",
    dyslexia_program_name: currUser.cert_area_of_need.map(area => area.area_of_need.name).toString(),
    ...therapistTreatmentDefaultProperties,
  });
};

const getTreatmentDefaultProperties = (treatment) => ({
  treatment_type: treatment.type_id,
  treatment_id: treatment.id,
  service_id: treatment.service,
});

const getStudentDefaultProperties = (state) => ({
  user_is_locked: selectIsLocked(state),
  therapist_connected: true, //TODO: check of teacher is online
  board_mode: selectBoardMode(state),
});

const getTreatmentV3DefaultProperties = (state, studentId) => {
  const currUser = currentUser(state);
  const treatment = selectTreatment(state);
    
  const treatmentProperties = treatment ? getTreatmentDefaultProperties(treatment) : {};
  const therapistOnlyProps = currUser.role === ROLES.THERAPIST.id ? getTherapistDefaultProperties(state, studentId, currUser, treatment) : {};
  const studentOnlyProps = currUser.role === ROLES.STUDENT.id ? getStudentDefaultProperties(state) : {};
  return {
    ...treatmentProperties,
    ...therapistOnlyProps,
    ...studentOnlyProps,
  };
};


export const trackTreatmentV3Event = (eventName, state, studentId, additionalParams = {}, callback = null) =>
  setTimeout(() => {
    try {
      trackEvent(eventName, { ...getTreatmentV3DefaultProperties(state, studentId), ...additionalParams });
      callback?.();
    } catch (e) {
      console.error(`failed to send student group analytics ${eventName}: ${e}`);
    }
  }, 1);
